import React from "react";
import VariantStockModification from "./warehouseWiseVariantStockDetails";
import TransferReservation from "./transferReservation";

const InventoryVariantTable = ({ variants, onInventoryUpdate }: any) => {
  const [currentVariant, setCurrentVariant] = React.useState<any>(null);
  const [currentVariantTransfer, setCurrentVariantTransfer] = React.useState<any>(null);
  const [isVariantStockModalOpen, setVariantStockModalOpen] = React.useState(false);
  const [isTransferReservationModalOpen, setTransferReservationModalOpen] = React.useState(false);

  const handleOpenVariantStockModal = (variant: any) => {
    setCurrentVariant(variant);
    setVariantStockModalOpen(true);
  };

  const handleOpenTransferReservationModal = (variant: any) => {
    setCurrentVariantTransfer(variant.id);
    setTransferReservationModalOpen(true);
  };

  const handleCloseVariantStockModal = () => {
    setCurrentVariant(null);
    setVariantStockModalOpen(false);
  };

  const handleCloseTransferReservationModal = () => {
    setCurrentVariantTransfer(null);
    setTransferReservationModalOpen(false);
  };

  return (
    <div className="relative px-4 py-4 border border-gray-200 rounded-lg shadow-sm bg-white">
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200 text-sm">
          <thead className="bg-gray-100">
            <tr>
              <th className="px-4 py-2 text-left font-semibold text-gray-600">ID</th>
              <th className="px-4 py-2 text-left font-semibold text-gray-600">Name</th>
              <th className="px-4 py-2 text-left font-semibold text-gray-600">Stock</th>
              <th className="px-4 py-2 text-left font-semibold text-gray-600">Reserved</th>
              <th className="px-4 py-2 text-left font-semibold text-gray-600">Available</th>
              <th className="px-4 py-2 text-left font-semibold text-gray-600">Actions</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {variants.map((variant: any) => (
              <tr key={variant.id} className="hover:bg-gray-50 transition">
                <td className="px-3 py-2 font-medium text-gray-800">{variant.id}</td>
                <td className="px-3 py-2 text-gray-700">{variant.name}</td>
                <td className="px-3 py-2 text-gray-700">{variant.stock.total_stock}</td>
                <td className="px-3 py-2 text-gray-700">
                  <div className="flex items-center gap-2">
                    <span className="font-semibold">{variant.stock.total_reserved}</span>
                    <span className="text-xs text-gray-400">(items reserved)</span>
                    <button
                      onClick={() => handleOpenTransferReservationModal(variant)}
                      className="text-blue-500 text-xs hover:underline"
                      aria-label="Merge Reservations"
                    >
                      Merge
                    </button>
                  </div>
                </td>
                <td className="px-3 py-2 text-gray-700">{variant.stock.available_for_sell}</td>
                <td className="px-3 py-2">
                  <button
                    className="text-indigo-600 hover:text-indigo-900"
                    onClick={() => handleOpenVariantStockModal(variant.id)}
                    aria-label="View in Warehouse"
                  >
                    View in Warehouse
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile view */}
      <div className="grid md:hidden gap-4 mt-4">
        {variants.map((variant: any) => (
          <div
            key={variant.id}
            className="p-4 border border-gray-200 rounded-lg shadow-sm bg-gray-50"
          >
            <div className="flex justify-between items-center mb-2">
              <span className="font-medium text-gray-800">ID: {variant.id}</span>
              <button
                className="text-indigo-600 text-sm hover:underline"
                onClick={() => handleOpenVariantStockModal(variant)}
              >
                View
              </button>
            </div>
            <div className="text-sm text-gray-700">
              <div>
                <strong>Name:</strong> {variant.name}
              </div>
              <div>
                <strong>Stock:</strong> {variant.stock.total_stock}
              </div>
              <div>
                <strong>Reserved:</strong> {variant.stock.total_reserved} items reserved
              </div>
              <div>
                <strong>Available:</strong> {variant.stock.available_for_sell}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Modals */}
      {isVariantStockModalOpen && (
        <VariantStockModification
          onSubmit={() => {
            onInventoryUpdate();
           
          }}
          isOpen={isVariantStockModalOpen}
          variant={currentVariant}
          onClose={handleCloseVariantStockModal}
        />
      )}
      {isTransferReservationModalOpen && (
        <TransferReservation
          onSubmit={() => {
            onInventoryUpdate();
            
          }}
          isOpen={isTransferReservationModalOpen}
          variant={currentVariantTransfer}
          onClose={handleCloseTransferReservationModal}
        />
      )}
    </div>
  );
};

export default InventoryVariantTable;
